{
  "A050": "policy.storno.termination-type.A050",
  "A080": "policy.storno.termination-type.A080",
  "A081": "policy.storno.termination-type.A081",
  "B290": "policy.storno.termination-type.B290"
}
